import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import { Translate } from 'react-redux-i18n';
import { ReactComponent as InvoiceGroup } from 'assets/group.svg';
import FlexGroup from 'components/FlexGroup';

const InvoiceNotifier = ({ onClick }) => (
    <FlexGroup center middle className="empty-result">
        <div>
            <InvoiceGroup />
            <div className="info">
                <Translate value="invoice_winner_notifier.import_info" />
            </div>
            <div>
                <Button color="primary" onClick={ onClick }>
                    <Translate value="import" />
                </Button>
            </div>
        </div>
    </FlexGroup>
);

InvoiceNotifier.propTypes = {
    onClick: PropTypes.func,
};

InvoiceNotifier.defaultProps = {
    onClick: () => {},
};

export default InvoiceNotifier;
